import { render, staticRenderFns } from "./TwinkleButton.vue?vue&type=template&id=22211bc8&"
import script from "./TwinkleButton.vue?vue&type=script&lang=js&"
export * from "./TwinkleButton.vue?vue&type=script&lang=js&"
import style0 from "./TwinkleButton.vue?vue&type=style&index=0&id=22211bc8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports